import { useAuth } from "@clerk/clerk-react";
import { OrganizationUserContext } from "contexts/Organization";
import { useContext } from "react";

import { fetcherAuth } from "./api";
import { getSource } from "./tracking";

export const useTracking = () => {
  const { getToken } = useAuth();
  const { currentOrg } = useContext(OrganizationUserContext);
  const trackUserHasOnboarded = async (action: string) => {
    await fetcherAuth(
      getToken,
      `/api/organization/${currentOrg?.id}/onboarding/track`,
      "POST",
      {},
      { action },
    );
  };

  const trackVaStep = async (route: string) => {
    localStorage.setItem(`${currentOrg?.id}-va-step`, route);

    try {
      await fetcherAuth(
        getToken,
        `/api/organization/${currentOrg?.id}/onboarding/track-va-step`,
        "POST",
        {},
        {
          page: route,
          source: getSource(),
          isSelfServe: true,
        },
      );
    } catch (error) {}
  };

  return { trackUserHasOnboarded, trackVaStep };
};
